module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-1-312d54faa4bbf56fcf56d3f11f659883.jpg";